import { render, staticRenderFns } from "./MpayJsSdkUI.vue?vue&type=template&id=20c59023&scoped=true"
import script from "./MpayJsSdkUI.vue?vue&type=script&lang=js"
export * from "./MpayJsSdkUI.vue?vue&type=script&lang=js"
import style0 from "./MpayJsSdkUI.vue?vue&type=style&index=0&id=20c59023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c59023",
  null
  
)

export default component.exports